import { BoxComponent } from '@/components/BoxComponent'
import { HeaderOfferComponent } from '../HeaderOfferComponent'
import styles from './VerPropostaComponente.module.css'
import { calcularDataDeEntrega } from '@/utils/calculateDeliveryDate'
import { useClient } from '@/contexts/ClientContext'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { useEffect, useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Button } from '@mui/material'
import { ImageSlider } from '@/pages/home/Components/ImageSlider'
import { formatarMoeda } from '@/utils/formatCurrency'
import DOMPurify from 'dompurify'
import { propostaApi } from '@/services/api/proposta'
import { CalculaDesconto } from '@/utils/calculaDesconto'
import { converterMoedaParaNumeroInteiro } from '@/utils/converterModelaParaNumero'

interface CondicaoPagamentoIF {
  id?: number
  proposta_financeira_id?: number
  entrada?: string
  tipo_pagamento?: 'PARCELADO' | 'ENTRADA_PARCELADO'
  quantidade_parcela?: number
  desconto_em_porcentagem?: number
  valor_com_desconto?: number
  valor_por_parcela?: number
}

interface VerPropostaComponenteProps {
  resumo: string
  descricao: string
  listaItens: string
  valorProposta?: number
  quantidadeParcelas?: number
  prazoEntrega?: string
  porcentagem?: string | number
  valorComDesconto?: string | number
  valorEntrada?: number
  valorEntradaComDesconto?: string | number
  descontoEntrada?: number
  imagens?: string[]
  tipoPagamento?: string
  parcelas?: { valor: string; forma_pagamento: string }[]
  id?: number
  condicaoPagamentoId?: number
}

export function VerPropostaComponente({
  resumo,
  descricao,
  valorProposta,
  prazoEntrega,
  porcentagem,
  valorComDesconto,
  imagens,
  tipoPagamento,
  valorEntrada,
  descontoEntrada,
  quantidadeParcelas,
  id, 
  condicaoPagamentoId
}: VerPropostaComponenteProps) {
  const { client, formatAddress } = useClient()
  const [expandido, setExpandido] = useState(false)
  const [condicaoPagamento, setCondicaoPagamento] = useState<CondicaoPagamentoIF | undefined>()

  // Usar o endereço do cliente diretamente
  const enderecoFormatado = formatAddress(client.endereco, client.enderecoEntrega)
  const dataDeEntrega = calcularDataDeEntrega(prazoEntrega ? parseInt(prazoEntrega) : undefined)

  const valorPropostaNumerico = Number(valorProposta) || 0;
const valorEntradaNumerico = Number(valorEntrada) || 0;
const quantidadeParcelasNumerico = Number(quantidadeParcelas) || 0;

let valorParcela = 0;

if (tipoPagamento === 'ENTRADA_PARCELADO') {
  valorParcela = (valorPropostaNumerico - valorEntradaNumerico) / quantidadeParcelasNumerico;
} else {
  valorParcela = valorPropostaNumerico / quantidadeParcelasNumerico;
}


  useEffect(() => {
    if(condicaoPagamentoId){
      propostaApi.buscarPorCondicaoPagamento(condicaoPagamentoId.toString()).then((response) => {
        console.log("response", response)
        setCondicaoPagamento({...response, entrada: formatarMoeda(Number(response.valor_proposta))})
      })
    }
  }, [])

  const mensagemEnvioProposta = () => {
    const nomeCompleto = client.dadosPessoais.nome
    const primeiroNome = nomeCompleto.split(" ")[0]
    return `Olá ${primeiroNome}, aqui está seu orçamento`
  }

  return (
    <div className={styles.container_ver_proposta}>
      <HeaderOfferComponent headerOfferEstyle={true} />
      <main className={styles.main}>
        <h4 className={styles.titulo}>{mensagemEnvioProposta()}:</h4>
        <BoxComponent className={styles.container}>
          {descricao.length <= 100 || expandido ? (
            <span
              className={styles.descricao_container}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(descricao),
              }}
            />
          ) : (
            <span
              className={styles.descricao_container}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(descricao.substring(0, 100)),
              }}
            />
          )}
          {descricao.length > 100 && (
            <Button
              className={styles.mostrar_mais}
              onClick={() => setExpandido(!expandido)}
            >
              {expandido ? (
                <>
                  <KeyboardArrowUpIcon /> Mostrar menos
                </>
              ) : (
                <>
                  <KeyboardArrowDownIcon /> Mostrar detalhes
                </>
              )}
            </Button>
          )}

          {imagens && imagens.length > 0 && (
            <div className={styles.container_imagem}>
              <ImageSlider
                images={imagens}
                onClose={close}
                botoesDeAcao={false}
                isProposta={true}
              />
            </div>
          )}

          <div className={styles.container_informacoes}>
          <div className={styles.informacoes}>
            {porcentagem && parseInt(porcentagem.toString()) > 0 && (
              <div className={styles.tipos_pagamento_container}>
                <span>💵 À vista:</span>
                <span className={styles.subtitulo}>
                  {formatarMoeda(valorComDesconto ?? 0)} ({porcentagem}% de desconto)
                </span>
              </div>
            )}

            {(tipoPagamento === 'ENTRADA_PARCELADO' || tipoPagamento === 'PARCELADO') && quantidadeParcelas && quantidadeParcelas > 0 ? (
              <>
                <div className={styles.tipos_pagamento_container}>
                  <span>💰 Valor total:</span>
                  <span className={styles.subtitulo}>{formatarMoeda(valorProposta ?? 0)}</span>
                </div>

                {tipoPagamento === 'ENTRADA_PARCELADO' && (
                  <div className={styles.lista_tipos_pagamento}>
                    <span className={styles.subtitulo}>💳 Com Entrada:</span>
                    <ul>
                      {valorEntrada ? (
                        <li className={styles.tipos_pagamento_container}>
                          <span>Entrada:</span>
                          <span className={styles.subtitulo}>
                            {descontoEntrada && descontoEntrada > 0
                              ? `${formatarMoeda(CalculaDesconto(valorEntrada, descontoEntrada))} (${descontoEntrada}% de desconto)`
                              : formatarMoeda(Number(valorEntrada ?? 0))}
                          </span>
                        </li>
                      ) : 
                      <li className={styles.tipos_pagamento_container}>
                          <span>Entrada:</span>
                          <span className={styles.subtitulo}>
                              {formatarMoeda(Number(valorEntrada ?? 0))}
                          </span>
                        </li>
                      }

                      <li className={styles.tipos_pagamento_container}>
                        <span>Parcelas:</span>
                        <span className={styles.subtitulo}>
                          {quantidadeParcelas}x {formatarMoeda((Number(valorProposta) - Number(valorEntrada)) / Number(quantidadeParcelas))}
                        </span>
                      </li>
                    </ul>
                  </div>
                )}

                {tipoPagamento === 'PARCELADO' && (
                  <div className={styles.tipos_pagamento_container}>
                    <span>💳 Parcelas:</span>
                    <span className={styles.subtitulo}>
                      {quantidadeParcelas}x {formatarMoeda(Number(valorProposta) / Number(quantidadeParcelas))}
                    </span>
                  </div>
                )}
              </>
            ) : (
              <div className={styles.tipos_pagamento_container}>
                <span>💰 Valor total:</span>
                <span className={styles.subtitulo}>{formatarMoeda(valorProposta ?? 0)}</span>
              </div>
            )}
          </div>



            <BoxComponent className={styles.informacoes}>
              <div className={styles.subtitulo_fechamento}>
                <span>
                  Fechando o pedido hoje, <br />
                  você recebe {resumo} a partir de
                </span>
              </div>

              <h2>{dataDeEntrega}</h2>

              <div className={styles.local_entrega}>
                <div className={styles.local}>
                  <LocationOnIcon />
                  <span>Entrega em:</span>
                </div>

                <p>{enderecoFormatado}</p>
              </div>
            </BoxComponent>
          </div>

          <BoxComponent className={styles.buttons}>
            <button type='button'>FALAR COM A VIVA</button>
            <button type='button'>FECHAR PEDIDO</button>
          </BoxComponent>
        </BoxComponent>
      </main>
    </div>
  )
}
